import axios from 'axios';

export const baseDomain = process.env.VUE_APP_BACKEND;

export const baseURL = `${baseDomain}/web/api/`;

export const Http = axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' }
});

export const getParams = (pairs) =>
    pairs.reduce((params, pair) => {
        if (pair.value) {
            return { ...params, [pair.key]: pair.value };
        }
        return params;
    }, {});

// La autenticación (Bearer, refresh ante 401, token de la URL) la maneja la estrategia de acceso del tenant
// (`core/auth`), que se conecta a este cliente desde `composition-root.ts`. Este módulo solo crea el cliente HTTP.

export default Http;
